import { render } from "./ImageZoom.vue?vue&type=template&id=24fe61b0&scoped=true&ts=true"
import script from "./ImageZoom.vue?vue&type=script&lang=ts"
export * from "./ImageZoom.vue?vue&type=script&lang=ts"

import "./ImageZoom.vue?vue&type=style&index=0&id=24fe61b0&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fe61b0"]])

export default __exports__